import Vue from 'vue'

const store = Vue.observable({
  cID: null,
  token: null,
  wishlist: {
    common_items: {},
    list: {}
  },
  loading: false,
  wishlistActive: false,
  customerCountry: 'NZ'
})

const actions = {
  initWishlist() {
    fetch('/collections/all?view=wishlist')
      .then((res) => res.json())
      .then((data) => {
        store.cID = data.customer_id
        store.token = data.access_token
        store.wishlist = data.wishlist
        let listKey = Object.keys(store.wishlist.list)[0]
        store.wishlistActive = data.wishlist.list[listKey] && data.wishlist.list[listKey].items.length
      })
      .catch((error) => {
        console.error(error)
      })
  },

  updateWishlist(pID, vID, inWishlist = false, listKey) {
    store.loading = true
    let wishlist_endpoint = ''
    let method = inWishlist ? 'DELETE' : 'POST'
    let data = {
      items: [
        {
          pid: pID,
          vid: vID
        }
      ]
    }

    if (Object.keys(store.wishlist.list).length === 0) {
      // create wishlist
      wishlist_endpoint = `/a/ps/${store.cID}/wishlist`
      data.default = true
      data.name = 'my moochi wishlist'
    } else {
      // update wishlist
      wishlist_endpoint = `/a/ps/${store.cID}/wishlist/${listKey}/items`
    }

    fetch(wishlist_endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'custom-token': store.token
      },
      body: JSON.stringify(data)
    })
      .then((res) => res.json())
      .then((data) => {
        store.wishlist = data.data
        let key = Object.keys(store.wishlist.list)[0]
        store.wishlistActive = store.wishlist.list[key] && store.wishlist.list[key].items.length
        store.loading = false
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}

Vue.prototype.$store = store
Vue.prototype.$actions = actions
